export default __webpack_public_path__ + "static/outlined-chart-409a64900a1c566f75ff41d814947298.svg";